/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';

import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { DBTaskForm } from '../../pages/common/forms/DBTaskForm';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';

import { ConnectedDialog } from '../ConnectedDialog';

export const DBTaskFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(closeDialog('dbTaskFormDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="dbTaskFormDialog">
      <div className="popup new_trello_card_popup" style={{ display: 'block' }}>
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>Create Card</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">{<DBTaskForm />}</div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey={'createTaskApi'} formName={'db-task-form'} text="Save" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
